import { toast } from "react-toastify";


export const notifySuccess = (message) => {
  toast(
    <div className="success_toast">
      <img src="/assets/banner/tick.svg" alt="success" className="dnoneinlight" />
      <img src="/assets/banner/ticklight.svg" alt="success" className="d-none showinlighttheme" />
      <div id="popup-login-success">
        <h4>Success</h4>
        <h5>{message}</h5>
      </div>
    </div>,
    {
      autoClose: 2000,
      className: "toast-success",
    }
  );
};


export const notifyWarning = (message) => {
  toast(
    <div className="warning_toast">
      <img src="/assets/banner/warning.svg" alt="warning" />
      <div>
        <h4>Warning</h4>
        <h5>{message}</h5>
      </div>
    </div>,
    {
      autoClose: 2000,
      className: "toast-warning",
    }
  );
};


export const notifyError = (heading, message) => {
  toast(
    <div className="error_toast">
      <img src="/assets/banner/cross.svg" alt="error" />
      <div>
        <h4>{heading}</h4>
        <h5>{message}</h5>
      </div>
    </div>,
    {
      autoClose: 2000,
      className: "toast-error",
    }
  );
};

export const notificationToast = (message) => {
  toast(
    <div className="notification-toast">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M9.41235 19.25C9.57327 19.5287 9.8047 19.7601 10.0834 19.921C10.3621 20.0819 10.6782 20.1666 11 20.1666C11.3218 20.1666 11.638 20.0819 11.9166 19.921C12.1953 19.7601 12.4268 19.5287 12.5877 19.25" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.99023 14.0489C2.87048 14.1801 2.79145 14.3433 2.76276 14.5187C2.73407 14.694 2.75696 14.8739 2.82863 15.0365C2.9003 15.1991 3.01767 15.3373 3.16646 15.4344C3.31526 15.5315 3.48906 15.5832 3.66673 15.5834H18.3334C18.511 15.5834 18.6849 15.5319 18.8338 15.435C18.9827 15.3381 19.1002 15.2 19.172 15.0375C19.2439 14.875 19.267 14.6952 19.2385 14.5198C19.2101 14.3445 19.1313 14.1812 19.0117 14.0498C17.7926 12.793 16.5001 11.4575 16.5001 7.33337C16.5001 5.87468 15.9206 4.47574 14.8892 3.44429C13.8577 2.41284 12.4588 1.83337 11.0001 1.83337C9.54137 1.83337 8.14243 2.41284 7.11098 3.44429C6.07953 4.47574 5.50006 5.87468 5.50006 7.33337C5.50006 11.4575 4.20665 12.793 2.99023 14.0489Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div>
        <h4>New Notification</h4>
        <h5>{message}</h5>
      </div>
    </div>,
    {
      autoClose: 4000,
      className: "toast-notification",
    }
  );
};



